import { useEffect, useRef } from 'react'
import { togglePlaybackPlaying } from 'actions/playback'
import { PLAYER_TYPE, PLAYBACK_STATE } from 'enums'
import { useAction } from 'hooks'
import { useSelector } from 'react-redux'
import { PlayerType } from 'types/common'

export const usePreviewSlider = ({ isMedia, preview }:{ isMedia:boolean, preview: PlayerType }) => {
  const sliderContainerRef = useRef<HTMLDivElement | null>(null)
  const memoPlayback = useRef(null)
  const togglePlayback = useAction(togglePlaybackPlaying)
  const playback = useSelector((state: RootState) => state.playback)

  useEffect(() => {
    const slider = sliderContainerRef.current
    const stop = () => {
      memoPlayback.current = isMedia
        ? playback.clipPlaybackState
        : playback.timelinePlaybackState
      isMedia
        ? togglePlayback({
          playbackState: PLAYBACK_STATE.PAUSE,
          playerType: PLAYER_TYPE.MEDIA,
        })
        : togglePlayback({
          playbackState: PLAYBACK_STATE.PAUSE,
          playerType: PLAYER_TYPE.TIMELINE,
        })
    }
    const start = () => {
      isMedia
        ? togglePlayback({
          playbackState: memoPlayback.current,
          playerType: PLAYER_TYPE.MEDIA,
        })
        : togglePlayback({
          playbackState: memoPlayback.current,
          playerType: PLAYER_TYPE.TIMELINE,
        })
      memoPlayback.current = null
    }
    if (slider) {
      slider.addEventListener('mousedown', stop)
      slider.addEventListener('mouseup', start)
    }
    return () => {
      if (slider) {
        slider.removeEventListener('mousedown', stop)
        slider.removeEventListener('mouseup', start)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ sliderContainerRef, preview, playback ])

  return {
    sliderContainerRef,
  }
}
